import { PROYECT } from "services/api";
import { saveAs } from 'file-saver';
import axios from "axios";
import { START_REQUEST_SEARCH } from "redux/reducers/search/searchReducer";
import { STOP_REQUEST_SEARCH } from "redux/reducers/search/searchReducer";
import { SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";


export const downloadReport =  (start, end, stations, unitType, token) => {
  const auth = { headers: { authorization: token } };
  const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/notes/units/sales-report?start=${start}&end=${end}&unitType=${unitType}&stations=${stations.join("&stations=")}`;
  const fileName = `ReporteLogins_${unitType}_${start}_${end}.xlsx`;

  return async (dispatch) => {
    dispatch({type: START_REQUEST_SEARCH});
    const startTime = performance.now();
    try {
      const response = await fetch(reportUrl, auth);
      const blob = await response.blob();
      
      const endTime = performance.now();
      const requestTime = (endTime - startTime)/1000;
      console.log(`Tiempo de espera ${requestTime} segundos`);

      if(response.status !== 200) throw JSON.parse(await blob.text())?.message?.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'XLSX Descargado con éxito', color: 'success' }
      });
      saveAs(blob, fileName);
    } catch (err) {
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: err.message?.error ? err.message.error : err, color: 'danger' }
      });
    }

    dispatch({type: STOP_REQUEST_SEARCH});
  };
};
